//AUTHOR: Philip Brown
//Last Modified: July 27, 2016

//********SUBMITTING DONATIONS
var transactionData = {};  //Store user data for post donation processing
var transactionLock = false;
var attemptCount = 0;
//Fields to avoid with paypal transactions
var paypalBlacklist = ["recurringDonation","storeCard","_payment.accountNumber","_payment.monthExpires_1","_payment.verification","_payment.yearExpires_1"];
$(function(){
	var payPalState = queryString.getQueryVariable('pp');
	if(payPalState && payPalState == 's'){ //s=success, f=fail
		displayNextActivityForm();
	}
})
function cleanse(orig){
	if(typeof orig == 'string')
		return orig.trim().replace(",","");
	return orig;
}
function validateDonationInteraction(email, cb){
	gRecordAction('donation', function(token){
		if(!token)
			return cb(false);
		$.ajax({
			type: 'POST',
			url: '/validate/recaptcha',
			data: { token: token, email: email },
			dataType: 'json',
			success: function(data){
				if(!data || !data.success){
					return cb(false);
				}
				return cb(true);
			}
		})
	})
}
function submitDonation(data){
	if(!transactionLock){
		transactionLock = true; //Set lock to prevent double click donations(will release on Kimbia success/failure)
		//Creating data object
		var donationData = {
			profile: {
				firstName: cleanse(data.FirstName),
				lastName: cleanse(data.LastName),
				email: cleanse(data.ContactEmail),
				address: {
					street1: cleanse(data.street1),
					street2: cleanse(data.street2),
					city: cleanse(data.city),
					state: cleanse(data.state),
					zipcode: cleanse(data.zipcode),
					country: cleanse(data.country)
				}
			},
			payment: {
				accountNumber: data['_payment\.accountNumber'].replace(/[^0-9]/g,""),
				verification: data['_payment\.verification'],
				monthExpires: data['_payment\.monthExpires_1'],
				yearExpires: data['_payment\.yearExpires_1']
			},
			forms: [{
				channelId: $('#aclj_kimbia_channelId').val(),
				type: $K.api.type.DONATION_FORM_TYPE,
				metadata: {
					"aclj_appealCode": getAppealCode(),
					"aclj_StoreToken":"false",
					"widgetReferrer":document.referrer
				},
				data: {
					name: "DonationLevel",
					amount: (parseInt(data.donationAmount) * 100),
					currency: 'USD',
					count: data.recurringDonation ? null : 1,
					interval: data.recurringDonation ? 'MONTHLY' : null,
				}
			}]
		}
		if(callCenterDonorId !== null)
			donationData.forms[0].metadata["aclj_ccDonorId"] = callCenterDonorId;
		if(callCenterId !== null)
			donationData.forms[0].metadata["aclj_ccId"] = callCenterId;
		if(typeof data.referral_source !== 'undefined' && data.referral_source !== null)
			donationData.forms[0].metadata["referral_source"] = data.referral_source;

		$('.donationHolder #SubmitButton button').addClass('active');
		$('.donationHolder #SubmitButton button i').show();

		//START DONATION REQUEST
		var submitId = "ACLJDonate" + ((new Date()).getTime()).toString();
		transactionData = {};
		transactionData = {
			profile: donationData.profile,
			recurring: data.recurringDonation,
			donTopicTag: data.donTopicTag,
			giftTopic: data.giftTopic || null
		}
		
		validateDonationInteraction(donationData.profile.email, function(valid){
			if(!valid){
				$('.kimbiaDonationForm').remove();
			}else{
				$K.api.submit(submitId, donationData, kimbiaProcessing); //Uses requestId generated earlier
			}
		})
	}
}
function submitPaypalDonation(data){
	if(!transactionLock){
		transactionLock = true;
		paypalLoading(true);
		var donData = {};
		if(callCenterDonorId !== null)
			donData.donId = callCenterDonorId;
		if(callCenterId !== null)
			donData.ccId = callCenterId;
		donData.amount = data.donationAmount;
		var memberInfo = {
			firstName: data.FirstName,
			lastName: data.LastName,
			email: data.ContactEmail,
			street1: data.street1,
			street2: data.street2,
			city: data.city,
			state: data.state,
			zip: data.zipcode,
			country: data.country
		}
		var password = data.storeCardPassword; //Not actually for storing cards, just using the same field
		if(typeof password !== "undefined" && password !== null && password !== ''){
			saveMemberInfo(memberInfo);
			var memberData = fetchMemberInfo();
			var loginData = {
				firstName:memberData.firstName,
				lastName:memberData.lastName,
				email:memberData.email,
				password:password,
				timestamp:data.timestamp
			}
			var status = {success:false};
			loginWithOptions(loginData,{async:false,silent:true},function(status){ return function(member){
				if(member === null)
					errorDisplayAndTrack("It looks like you already have an account. Please try logging in with the correct password");
				else{
					$('#memberName #nameSpan').text(member.firstName);
					//No need to display progress tiles next to member name, will only send successful donation given full address
					toggleLoginButtons();
					status.success=true;
				}
			}}(status));
			if(status.success ===false){
				transactionLock = false;
				paypalLoading(false);
				return false;
			}
		}else{
			saveMemberInfo(memberInfo); //Still need to save the member to the cookie
		}
		//Grab Donee first and last name if available
		var doneeFirst = $('#DonorFirstName input').length? $('#DonorFirstName input').val() : null;
		var doneeLast = $('#DonorLastName input').length? $('#DonorLastName input').val() : null;
		$.ajax({
			type: 'POST',
			url: '/paypal/donate',
			data: {
				timestamp: data.timestamp,
				charge: data.donationAmount,
				topicTag: data.donTopicTag,
				giftTopic: data.giftTopic || null,
				doneeFirst: doneeFirst,
				doneeLast: doneeLast
			},
			dataType: 'json',
			success: function(data){
				if(data && data.success){
					reportDonation(data.charge, Date.now(), data.id);
					window.location = data.redirect;
				}else{
					errorDisplayAndTrack("Unable to start a PayPal transaction at this time.");
					transactionLock = false;
					paypalLoading(false);
				}
			}
		})
	}
}
function paypalLoading(show){
	if(show){
		$('#PaypalButton i').show();
		$('.payWithPayPal i').show();
	}else{
		$('.payWithPaypal i').hide();
		$('#PaypalButton i').hide();
	}
}
function creditLoading(show){
	if(show){
		$('.payWithCredit i').show();
	}else{
		$('.payWithCredit i').hide();
	}
}
//CALLED MULTIPLE TIMES WHILE KIMBIA IS PROCESSING TRANSACTION
function kimbiaProcessing(state, response){
	//POSSIBLE RESPONSES
	switch(state){
		case $K.api.state.DATA_VALIDATION_FAILURE:
			//IF KIMBIA API VALIDATION FAILS
			transactionLock = false;
			donationFailure('Donation validation failure', response);
			break;
		case $K.api.state.FAILURE:
			//IF KIMBIA API CALL FAILS
			transactionLock = false;
			donationFailure("Donation failure", response);
			break;
		case $K.api.state.IN_PROGRESS:
			//IF KIMBIA API CALL IS STILL IN PROGRESS
			//console.log("Donation processing");
			break;
		case $K.api.state.PRE_CALL:
			//BEFORE KIMBIA API CALL IS MADE
			//console.log("Starting donation processing");
			break;
		case $K.api.state.SUCCESS:
			//KIMBIA API CALL WAS SUCCESSFULLY COMPLETED
			transactionLock = false;
			finishDonation(response);
			break;
		case $K.api.state.UNKNOWN:
			//UNKNOWN ERROR HAS OCCURRED
			transactionLock = false;
			donationFailure("Unknown donation error occurred", response);
			break;
		default:
			break;
	}
}
function donationFailure(customError, response){
	var message = response.messages;
	if(message && message.length > 0) message = message[0];
	attemptCount++;
	if(attemptCount == 3){   //Transition to paypal on third failed transaction
		errorDisplayAndTrack("Our credit card processor is overloaded right now, try paypal or come back later.", null, customError);
		acljScrollTo('#contentArea');
		showBackupDonationMethod();
		return;
	}
	if(message == '' || !message.match('credit')) message = "Donation failed, please check your information and try again";
	errorDisplayAndTrack(message, null, customError);
	$('.donationHolder #SubmitButton button').removeClass('active');
	$('.donationHolder #SubmitButton i').hide();
}
function finishDonation(response){
	attemptCount = 0;
	//VISUAL INDICATION OF SUCCESS
	$('.donationHolder #SubmitButton button').removeClass('active');
	$('.donationHolder #SubmitButton i').hide();
	console.log("Donation Successful");
	kimbiaTransactionCode = response.response.transactionCode;
	showDonationThankYou(true);
	var charge = response.response.fullPrice || response.response.discountedPrice;
	charge = charge.replace("$", "").replace(/,/g,"");
	var recurring = transactionData.recurring;
	var topicTag = transactionData.donTopicTag;
	var profile = transactionData.profile;
	var member = {};
	if(profile.firstName) member.firstName = profile.firstName;
	if(profile.lastName) member.lastName = profile.lastName;
	if(profile.email) member.email = profile.email;
	if(profile.address.street1) member.street1 = profile.address.street1;
	if(profile.address.street2) member.street2 = profile.address.street2;
	if(profile.address.city) member.city = profile.address.city;
	if(profile.address.state) member.state = profile.address.state;
	if(profile.address.zipcode) member.zip = profile.address.zipcode;
	if(profile.address.country) member.country = profile.address.country;

	saveMemberInfo(member);              //Cookie Update
	saveDonation(charge, topicTag, recurring, transactionData.giftTopic);
	reportDonation(charge, Date.now(),kimbiaTransactionCode); //Facebook Pixel
	displayNextActivityForm();
	window.dispatchEvent(new Event('donationFinished'));
}


//*********DONATION FORM HANDLING
var nameFields = null; //storage for current address field info
var currentCountry = null;

$('.donationHolder').on('blur', 'input', function(){
	trimInput(this)
	validateDonationItem(this);
});
$('.donationHolder').on('blur', 'select', function(){
	validateDonationItem(this);
});
$('.donationHolder #country select').on('change', function(){
	rebuildAddressFields($(this).val());
});
$('.donationHolder #country select').on('blur', function(){
	if($(this).val() !== currentCountry)     //PREVENT FORM FROM RELOADING IF COUNTRY IS UNCHANGED
		rebuildAddressFields($(this).val());
});
$('.donationHolder').on('change', 'select', hideErrorMessage);
$('.donationHolder').on('keydown', 'input', hideErrorMessage);

$('#PaymentProcessorSelection .payWithCredit').click(function(e){
	e.preventDefault();
	if(!$('#PaymentProcessorSelection').hasClass('credit')){
		$('#CreditCardForm').addClass('maximized');
		$('#PaymentProcessorSelection').removeClass('paypal');
		$('#PaymentProcessorSelection').addClass('credit');
	}
	else{
		processDonateClick(false);
	}
});
$('#PaymentProcessorSelection .payWithPayPal').click(function(e){
	e.preventDefault();
	if($('#PaymentProcessorSelection').hasClass('credit')){
		$('#CreditCardForm').removeClass('maximized');
		$('#PaymentProcessorSelection').removeClass('credit');
		$('#PaymentProcessorSelection').addClass('paypal');
		$('#PaymentProcessorSelection').addClass('confirm');
	}
	processDonateClick(true);
})

$('.donationHolder #SubmitButton button').click(function(){
	processDonateClick(false);
});
$('.donationHolder #PaypalButton button').click(function(){
	processDonateClick(true);
})
function processDonateClick(isPaypal){
	var data = $('.kimbiaDonationForm').find('input,select');
	var formItems = {};
	var formData = {};
	var valid = true;
	for(var i = 0; i < data.length; i++){
		if(typeof $(data[i]).attr('name') !== 'undefined' && $(data[i]).attr('name') !== ""){
			var name = $(data[i]).attr('name');
			if(!isPaypal || paypalBlacklist.indexOf(name) == -1){
				formItems[$(data[i]).attr('name')] = $(data[i]);
				formData[$(data[i]).attr('name')] = ($(data[i]).val() === 'on')? ((typeof $(data[i]).is(':checked') !== 'undefined')? $(data[i]).is(":checked") : false) : $(data[i]).val();
			}
		}
	}
	//VALIDATE THE BASIC FORM
	valid = validateDonationForm(formItems);
	//VALIDATE THE DONATION AMOUNT
	if(validDonation($('.kimbiaDonationForm .donationAmounts'))){
		formData.donationAmount = getDonationAmount($('.kimbiaDonationForm .donationAmounts'));
	}else{
		valid = false;
		errorDisplayAndTrack('Please select/enter a donation amount greater than $5');
	}
	// Allowing Test Donations to be made on prod mobile donate to pass iOS review
	if (valid && $('.mobileDonationForm').length > 0 && $('#CCNumber input').val() === '4111111111111111' && $('#CCVerification input').val() === '111' && $('#CCMonth select').val() === "11" && $('#CCYear select').val() === "2025") {
		$('.donationHolder #SubmitButton button').addClass('active'); // Change button to green
		$('.donationHolder #SubmitButton button i').show(); // Show spinner
		return setTimeout(function () { // Wait 1.5 seconds, then show thank you
			showDonationThankYou(false);
			displayNextActivityForm();
		}, 1500);
	}
	var member = fetchMemberInfo();
	//NEED TO PERFORM CHECK FOR CHECKED SAVE STATUS BUT MISSING PASSWORD(if invalid, set valid = false)
	if(!isPaypal && valid && formData.storeCard && formData.storeCardPassword == '' && (typeof member == 'undefined' || member == null || typeof member.sessionKey == 'undefined')){
		errorDisplayAndTrack("You need to login or enter a password in order to save this card.");
	}else{
		if(valid){
			if(typeof member !== 'undefined' && member !== null)
				formData.referral_source = member.source || null;
			confirmDonationThreshold(parseInt(formData.donationAmount), function(confirmed){
				if(confirmed){
					if(this.isPaypal){
						$('#PaymentProcessorSelection').addClass('paypal');
						$('#PaymentProcessorSelection').addClass('confirm');
						setTimeout(function(){
							paypalLoading(true);
						},100);
						submitPaypalDonation(this.formData);
					}else{
						$('#PaymentProcessorSelection').addClass('confirm');
						setTimeout(function(){
							creditLoading(true);
						},100);
						submitDonation(this.formData);
					}
				}
			}.bind({formData:formData, isPaypal: isPaypal}));
		}
	}
}
function validateDonationForm(data){
	var valid = true;
	for(var key in data){
		if(!validateDonationItem(data[key])) valid = false;
	}
	return valid;
}
//VALIDATE CHANGES
function validateDonationItem(inThis){
	var _this = inThis;
	var clean = true;
	var label = $(_this).attr('placeholder');
	var name = $(_this).attr('name');
	var div = $(_this).parent();
	var errorSpan = $(div).find('span.errorContainer');
	if(name === 'giftTopic'){
		if($(_this).val().trim() === ''){
			clean = false;
			errorDisplayAndTrack("Please pick a topic first");
			acljScrollTo("#PickACause", -35);
		}
	}else if(errorSpan && errorSpan.length > 0){
		if($(_this).val() === '' || $(_this).val() === 'NULL'){  //Default select val should be 'NULL'
			$(errorSpan).show();
			$(_this).addClass('error');
			clean = false;
		}
		//Perform REGEX validations
		if($(_this).attr('name') == 'ContactEmail'){              //EMAIL
			var message = $(errorSpan).find('span.errorText');
			if($(_this).val() !== '' && !$(_this).val().match(/^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i)){
				$(errorSpan).show();
				$(_this).addClass('error');
				$(message).text('Please use the format email@domain.com');          //CHANGE ERROR MESSAGE TO RELATE TO FAILED REGEX
				clean = false;
			}else{
				$(message).text(label + ' is required.');         //RESET TO DEFAULT ERROR MESSAGE
			}
		}
		if($(_this).attr('name') == '_payment.accountNumber'){   //CREDIT CARD NUMBER
			var invalid = false;
			var message = $(errorSpan).find('span.errorText');
			if($(_this).val() !== ''){
				var cardNumber = $(_this).val();
				cardNumber = cardNumber.replace(/[^0-9]/g,'');
				var cardDetails = sharedFunctions.creditCardType(cardNumber);
				if(typeof cardDetails == 'undefined' || typeof cardDetails.length == 'undefined' || cardDetails.length == 0){
					invalid = true;
				}else{
					invalid = true;
					for(var i = 0; i < cardDetails.length; i++){
						if(typeof cardDetails[i].lengths == 'undefined' || cardDetails[i].lengths.indexOf(cardNumber.length) !== -1){
							invalid = false;
							break;
						}
					}
				}
				if(invalid){
					$(errorSpan).show();
					$(_this).addClass('error');
					var message = $(errorSpan).find('span.errorText');
					$(message).text('Invalid Card Number. Please try again');
					clean = false;
				}
			}else{
				$(message).text(label + ' is required.');
			}
		}
		if($(_this).attr('name') == '_payment.verification'){     //CCV NUMBER
			var message = $(errorSpan).find('span.errorText');
			if($(_this).val() !== '' && !$(_this).val().match('^[0-9]{3,4}$')){
				$(errorSpan).show();
				$(_this).addClass('error');
				$(message).text('Invalid verification code. Please use the last 3 digits from the signature bar on the back of your card. For American Express cards, please enter the 4 digits located on the right-front of your card.');
				clean = false;
			}else{
				$(message).text(label + ' is required.');
			}
		}
		if(nameFields[name] && nameFields[name].regex){   //OPTIONAL ADDRESS REGEX(ex. zipcode **auto)
			var message = $(errorSpan).find('span.errorText');
			if($(_this).val() !== '' && !($(_this).val().toUpperCase()).match(nameFields[name].regex)){
				$(errorSpan).show();
				$(_this).addClass('error');
				$(message).text(nameFields[name].regexErrorMessage);
				clean = false;
			}else{
				$(message).text(label + ' is required.');
			}
		}
	}
	//If the field is not required, don't process
	return clean;
}

//HIDES ERROR MESSAGE SPAN
function hideErrorMessage(){
	var div = $(this).parent('div');
	var span = $(div).find('span.errorContainer');
	if(span && span.length > 0){
		$(span[0]).hide();
		$(this).removeClass('error');
	}
}

//CUSTOM FUNCTION TO REBUILD DONATION ADDRESS FORM
function rebuildAddressFields(countryCode){
	currentCountry = countryCode;
	nameFields = {};
	var fields = sharedFunctions.getAddressFieldsByCountryCode(countryCode);  //found in addressFields.js
	var finalForm = '';
	var foundParts = {}
	var columnCounter = 0;
	for(var i = 0; i < fields.length; i++){
		var f = fields[i].name;
		foundParts[f] = fields[i];
		nameFields[f] = fields[i];
		if(f === 'city' || f === 'state' || f === 'zipcode')
			columnCounter++;     							 //Count number of columns in last row for styling
	}
	if(foundParts.street1)
		finalForm += buildFormItem({
						item: foundParts.street1,           //Data related to field
						classes: 'donation_label',          //Classes to add to div(space seperated)
						label: 1,                           //Include Label (boolean)
						columns: 1,                         //Number of columns for styling
						required: {                         //Toggle span for error text
							outerClass: 'errorContainer',
							innerClass: 'errorText'
						},
						preId: 'donation'
					});
	if(foundParts.street2)
		finalForm += buildFormItem({
						item: foundParts.street2,
						classes: 'donation_label label_hidden',
						label: 1,
						columns: 1,
						preId: 'donation'
					});
	if(foundParts.city)
		finalForm += buildFormItem({
						item: foundParts.city,
						classes: 'donation_label label_hidden',
						label: 1,
						columns: columnCounter,
						required: {
							outerClass: 'errorContainer',
							innerClass: 'errorText'
						},
						preId: 'donation'
					});
	if(foundParts.state)
		finalForm += buildFormItem({
						item: foundParts.state,
						classes: 'noLabel',
						label: 0,
						columns: columnCounter,
						required: {
							outerClass: 'errorContainer',
							innerClass: 'errorText'
						},
						preId: 'donation'
					});
	if(foundParts.zipcode)
		finalForm += buildFormItem({
						item: foundParts.zipcode,
						classes: 'noLabel',
						label: 0,
						columns: columnCounter,
						required: {
							outerClass: 'errorContainer',
							innerClass: 'errorText'
						},
						preId: 'donation'
					});
	//Replace original address fields
	$('#AddressFields').empty();
	$('#AddressFields').append(finalForm);
}

//GENERIC FUNCTION TO BUILD FORM ITEMS (W/ OPTIONAL LABEL)
function buildFormItem(options){
	if(typeof options.columns !== 'undefined')
		options.classes = 'col'+options.columns+' '+options.classes;
	var html = '<div id=\"'+options.item.name+'\" class=\"'+options.classes+'\">';
	if(options.label) html += '<label>'+((options.item.name === 'street1')? 'Address' : ((options.item.name === 'street2')? 'Address 2' : options.item.label))+'</label>';
	var upperCaseName = options.item.name.charAt(0).toUpperCase() + options.item.name.slice(1);  //For camelCase with preId option
	if(typeof options.item.options === 'object' && options.item.options !== null){
		if(options.inputClasses)
			html+=createSelectTag(options.item.name, options.item.options, options.item.label, options.inputClasses);
		else
			html+=createSelectTag(options.item.name, options.item.options, options.item.label);
	}else{
		if(options.inputClasses)
			html+='<input class=\"'+options.inputClasses+'\" id=\"'+((options.preId)? options.preId + upperCaseName : options.item.name)+'\" type=\"text\" name=\"'+options.item.name+'\" placeholder=\"'+options.item.label+'\"></input>';
		else
			html+='<input id=\"'+((options.preId)? options.preId + upperCaseName : options.item.name)+'\" type=\"text\" name=\"'+options.item.name+'\" placeholder=\"'+options.item.label+'\"></input>';
	}
	
	if(options.required) html += createErrorSpan(options.item.label, options.required.outerClass, options.required.innerClass);
	html += '</div>'
	return html;
}

function createErrorSpan(text, outerClass, innerClass){
	var html = '';
	html += '<span class=\"'+outerClass+'\">';
	html += '<span class=\"'+innerClass+'\">'+text+' is required.</span>';
	html += '</span>';
	return html;
}

//FUNCTION TO BUILD SELECT TAG USING INPUT OPTION OBJECT
function createSelectTag(name, options, placeholder, classes){ //option must be an object
	if(classes)
		var select = '<select class=\"'+classes+'\" name=\"'+name+'\">';
	else
		var select = '<select name=\"'+name+'\">';
	if(placeholder) select+='<option value=\"NULL\">-'+placeholder+'-</option>';
	for(var key in options){
		select+='<option value=\"'+key+'\">'+options[key]+'</option>';
	}
	select+='</select>';
	return select;
}
function showDonationThankYou(showCardSave){
	if(typeof showCardSave == "undefined") showCardSave = true;
	$('.donationThankYouHolder').show();
	if(showCardSave){
		$('.saveThisCardHolder').show();
	}
}
$('button.saveCard').click(function(e){
	e.preventDefault();
	var member = fetchMemberInfo();
	$.post('/donate/save-card',{transactionCode:kimbiaTransactionCode},function(data){
		//NOTE: schedule an update of the cookie
		var fifteenMinsFromNow = new Date();
		fifteenMinsFromNow.setMinutes(fifteenMinsFromNow.getMinutes()+15);
		lookForMemberInfoUpdatesAfter(fifteenMinsFromNow);
		$('.saveThisCardHolder').hide();
	},'json');
})